import {DeleteRounded, EditRounded, InfoOutlined} from "@mui/icons-material";
import {Button, Stack} from "@mui/material";
import {ColumnActionProps} from "../../types/ColumnActionProps";
import {H5, Small} from "../Typography";
import {DriverFormData, IDriver} from "../../types/Driver";

const DriverListColumnShape = (props: ColumnActionProps<DriverFormData>) => {
    return [
        {
            Header: "Nom",
            accessor: "name",
            minWidth: 200,
        }, {
            Header: "Numéro de Permis",
            accessor: "drivingLicenseId",
            minWidth: 200,
        },
        {
            Header: "Sexe",
            accessor: "gender",
            minWidth: 100,
        },
        {
            Header: "Date de Naissance",
            accessor: "dateOfBirth",
            minWidth: 100,
            Cell: ({value}: any) => (
                <Small>
                    {new Date(value).toDateString()}
                </Small>
            ),
        },
        {
            Header: "Modèle de Voiture",
            accessor: "carName",
            minWidth: 200,
        },
        {
            Header: "Plaque d'Immatriculation",
            accessor: "licensePlate",
            minWidth: 200,
        },
        {
            Header: "Creation",
            accessor: "createdAt",
            minWidth: 100,
            Cell: ({value}: any) => (
                <Small>
                    {new Date(value).toDateString()}
                </Small>
            ),
        }, {
            Header: "Dernière Modification",
            accessor: "updatedAt",
            minWidth: 100,
            Cell: ({value}: any) => (
                <Small>
                    {new Date(value).toDateString()}
                </Small>
            ),
        },
        {
            Header: "Actions",
            accessor: "",
            minWidth: 200,
            Cell: ({row}: any) => (
                <Stack direction={"row"} alignItems={"center"}>
                    <Button startIcon={<InfoOutlined/>}
                            onClick={() => props.onViewDetailsAction(row.original)}>
                        Plus d'info
                    </Button>
                </Stack>
            )
        }
    ]
}

export default DriverListColumnShape
